export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 128;
export const evaluatePasswordRules = (password) => ({
    minLength: password.length >= MIN_PASSWORD_LENGTH,
    maxLength: password.length <= MAX_PASSWORD_LENGTH,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
});
export const allRulesSatisfied = (rules) => rules.minLength &&
    rules.maxLength &&
    rules.uppercase &&
    rules.lowercase &&
    rules.number &&
    rules.special;
export const validatePasswordStrength = (password) => {
    const rules = evaluatePasswordRules(password);
    if (!rules.minLength) {
        return { valid: false, reason: `Password must be at least ${MIN_PASSWORD_LENGTH} characters.` };
    }
    if (!rules.maxLength) {
        return { valid: false, reason: `Password must be ${MAX_PASSWORD_LENGTH} characters or fewer.` };
    }
    if (!rules.uppercase) {
        return { valid: false, reason: 'Password must contain at least one uppercase letter.' };
    }
    if (!rules.lowercase) {
        return { valid: false, reason: 'Password must contain at least one lowercase letter.' };
    }
    if (!rules.number) {
        return { valid: false, reason: 'Password must contain at least one number.' };
    }
    if (!rules.special) {
        return { valid: false, reason: 'Password must contain at least one special character.' };
    }
    return { valid: true };
};
export const PASSWORD_RULE_LABELS = [
    { key: 'minLength', label: `At least ${MIN_PASSWORD_LENGTH} characters` },
    { key: 'uppercase', label: 'An uppercase letter (A\u2013Z)' },
    { key: 'lowercase', label: 'A lowercase letter (a\u2013z)' },
    { key: 'number', label: 'A number (0\u20139)' },
    { key: 'special', label: 'A special character (e.g. !@#$%)' },
];
